/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceLineType } from './BalanceLineType';
import {
    BalanceLineTypeFromJSON,
    BalanceLineTypeFromJSONTyped,
    BalanceLineTypeToJSON,
    BalanceLineTypeToJSONTyped,
} from './BalanceLineType';
import type { AccountCategory } from './AccountCategory';
import {
    AccountCategoryFromJSON,
    AccountCategoryFromJSONTyped,
    AccountCategoryToJSON,
    AccountCategoryToJSONTyped,
} from './AccountCategory';

/**
 * 
 * @export
 * @interface UpdateTransactionCodeRequest
 */
export interface UpdateTransactionCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionCodeRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionCodeRequest
     */
    isCredit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionCodeRequest
     */
    isDebit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionCodeRequest
     */
    requiresClass: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionCodeRequest
     */
    requiresAppointment: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionCodeRequest
     */
    requiresBalanceApproval: boolean | null;
    /**
     * 
     * @type {AccountCategory}
     * @memberof UpdateTransactionCodeRequest
     */
    category: AccountCategory | null;
    /**
     * 
     * @type {BalanceLineType}
     * @memberof UpdateTransactionCodeRequest
     */
    balanceLineType: BalanceLineType | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionCodeRequest
     */
    isDeferrable: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionCodeRequest
     */
    appliesToTransactionCode?: string | null;
}



/**
 * Check if a given object implements the UpdateTransactionCodeRequest interface.
 */
export function instanceOfUpdateTransactionCodeRequest(value: object): value is UpdateTransactionCodeRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isCredit' in value) || value['isCredit'] === undefined) return false;
    if (!('isDebit' in value) || value['isDebit'] === undefined) return false;
    if (!('requiresClass' in value) || value['requiresClass'] === undefined) return false;
    if (!('requiresAppointment' in value) || value['requiresAppointment'] === undefined) return false;
    if (!('requiresBalanceApproval' in value) || value['requiresBalanceApproval'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('balanceLineType' in value) || value['balanceLineType'] === undefined) return false;
    if (!('isDeferrable' in value) || value['isDeferrable'] === undefined) return false;
    return true;
}

export function UpdateTransactionCodeRequestFromJSON(json: any): UpdateTransactionCodeRequest {
    return UpdateTransactionCodeRequestFromJSONTyped(json, false);
}

export function UpdateTransactionCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTransactionCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'isCredit': json['isCredit'],
        'isDebit': json['isDebit'],
        'requiresClass': json['requiresClass'],
        'requiresAppointment': json['requiresAppointment'],
        'requiresBalanceApproval': json['requiresBalanceApproval'],
        'category': AccountCategoryFromJSON(json['category']),
        'balanceLineType': BalanceLineTypeFromJSON(json['balanceLineType']),
        'isDeferrable': json['isDeferrable'],
        'appliesToTransactionCode': json['appliesToTransactionCode'] == null ? undefined : json['appliesToTransactionCode'],
    };
}

export function UpdateTransactionCodeRequestToJSON(json: any): UpdateTransactionCodeRequest {
    return UpdateTransactionCodeRequestToJSONTyped(json, false);
}

export function UpdateTransactionCodeRequestToJSONTyped(value?: UpdateTransactionCodeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'isCredit': value['isCredit'],
        'isDebit': value['isDebit'],
        'requiresClass': value['requiresClass'],
        'requiresAppointment': value['requiresAppointment'],
        'requiresBalanceApproval': value['requiresBalanceApproval'],
        'category': AccountCategoryToJSON(value['category']),
        'balanceLineType': BalanceLineTypeToJSON(value['balanceLineType']),
        'isDeferrable': value['isDeferrable'],
        'appliesToTransactionCode': value['appliesToTransactionCode'],
    };
}

